import { render } from "./PopUpProfile.vue?vue&type=template&id=69ac134c"
import script from "./PopUpProfile.vue?vue&type=script&lang=js"
export * from "./PopUpProfile.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__